import React from 'react';
import { CSSTransition } from 'react-transition-group';
import './fade.module.scss';

export const Fade = ({ children, ...props }) => {
    return (
        <CSSTransition timeout={300} classNames="fade" {...props}>
            {children}
        </CSSTransition>
    );
};

export const FadeUp = ({ children, ...props }) => {
    return (
        <CSSTransition timeout={300} classNames="fade-up" {...props}>
            {children}
        </CSSTransition>
    );
};
